<template>
  <component
    :is="asyncComponent"
    class="sdv-smart-block-item"
    :settings="item ? item.settings : {}"
    :context="context"
    @action="onAction"
    @call-event="onSmartblockEvent"
    @analytics="onAnalytics"
  />
</template>
<script lang="ts">
/**
 * Renders a single smartblock item.
 */
import { ExperienceActivationContext } from 'sd-types/app/experience/activation'
import { ActivationTemplate } from 'sd-types/models/activation'
import { defineComponent, PropType, toRefs } from 'vue-demi'
import { importSmartblockRef } from '../../utils/import-smartblock'
import { useSmartblockOptions } from '../../composables/internals/use-smartblock-option'
import { defineSmartblockEventEmits, useBypassSmartblockEvents } from '../../composables/use-smartblock-events'

export default defineComponent({
  name: 'SmartblockItem',
  props: {
    context: {
      type: Object as PropType<ExperienceActivationContext>,
      default: () => ({})
    },
    item: {
      type: Object as PropType<ActivationTemplate>,
      required: true
    }
  },
  emits: {
    ...defineSmartblockEventEmits()
  },
  setup (props, context) {
    const options = useSmartblockOptions()
    const { item } = toRefs(props)
    const asyncComponent = importSmartblockRef(item, { smartblockVersion: options.defaultVersion as string })
    return {
      asyncComponent,
      ...useBypassSmartblockEvents(context)
    }
  }
})
</script>
